import { g as getRoomType } from './get-room-type.js';
import { t as translateDate } from './translate-date.js';
import './index2.js';

const idAlbergoDictionary = {
  'Breathless Cabo San Lucas': '13736',
  'Breathless Cancun Soul Resort & Spa': '23836',
  'Breathless Montego Bay': '14102',
  'Breathless Punta Cana Resort & Spa': '11678',
  'Breathless Riviera Cancun Resort & Spa': '13918',
  'Dreams Acapulco Resort & Spa': '14100',
  'Dreams Aventuras Riviera Maya': '10578',
  'Dreams Bahia Mita Surf & Spa': '23142',
  'Dreams Cozumel Cape Resort and Spa': '24244',
  'Dreams Curacao Resort Spa and Casino': '20971',
  'Dreams Dominicus La Romana': '14101',
  'Dreams Flora Resort & Spa': '24784',
  'Dreams Huatulco': '10583',
  'Dreams Jade Resort & Spa': '10343',
  'Dreams Karibana Cartagena Golf & Spa Resort': '24762',
  'Dreams Las Mareas Costa Rica': '12346',
  'Dreams Los Cabos Golf Resort & Spa': '10584',
  'Dreams Macao Beach Punta Cana Resort and Spa': '21074',
  'Dreams Natura': '19903',
  'Dreams Onyx Resort & Spa': '11353',
  'Dreams Playa Bonita Panama': '14097',
  'Dreams Playa Mujeres Golf & Spa Resort': '14099',
  'Dreams Riviera Cancun Resort & Spa': '10577',
  'Dreams Royal Beach Punta Cana': '10344',
  'Dreams Sands Cancun': '12069',
  'Dreams Sapphire': '10345',
  'Dreams Tulum': '10579',
  'Dreams Vallarta Bay': '10342',
  'Dreams Vista Cancun Golf & Spa Resort': '18179',
  'Now Emerald Cancun': '20968',
  'Secrets Akumal Riviera Maya': '13202',
  'Secrets Aura Cozumel': '11094',
  'Secrets Bahia Mita Surf & Spa': '23143',
  'Secrets Cap Cana Resort & Spa': '14098',
  'Secrets Huatulco Resort & Spa': '10570',
  'Secrets Maroma Beach Riviera Cancun': '10568',
  'Secrets Moxche Playa del Carmen': '17154',
  'Secrets Papagayo Costa Rica Resort & Spa': '13491',
  'Secrets Playa Mujeres Golf & Spa Resort': '12070',
  'Secrets Puerto Los Cabos Golf & Spa Resort': '11302',
  'Secrets Riviera Cancun': '23253',
  'Secrets Royal Beach Punta Cana': '10569',
  'Secrets St. James Montego Bay': '10573',
  'Secrets St. Martin Resort & Spa': '20640',
  'Secrets The Vine Cancun': '10574',
  'Secrets Vallarta Bay Puerto Vallarta': '10575',
  'Secrets Wild Orchid Montego Bay': '10572',
  'Sunscape Akumal Beach Resort & Spa': '20967',
  'Sunscape Curacao': '10934',
  'Sunscape Dorado Pacifico Ixtapa': '10562',
  'Sunscape Puerto Plata': '14311',
  'Sunscape Puerto Vallarta': '14161',
  'Sunscape Sabor Cozumel': '11095',
  'Zoetry Agua Punta Cana': '10564',
  'Zoetry Casa Del Mar': '24114',
  'Zoetry Curacao': '24242',
  'Zoetry Montego Bay': '14580',
  'Zoetry Paraiso de la Bonita': '10563',
  'Zoetry Villa Rolandi Isla Mujeres': '12506',
};

const dcDictionary = {
  'Breathless Cabo San Lucas': '8178',
  'Breathless Cancun Soul Resort & Spa': '2530',
  'Breathless Montego Bay': '3118',
  'Breathless Punta Cana Resort & Spa': '9387',
  'Breathless Riviera Cancun Resort & Spa': '8154',
  'Dreams Acapulco Resort & Spa': '3284',
  'Dreams Aventuras Riviera Maya': '562',
  'Dreams Bahia Mita Surf & Spa': '6830',
  'Dreams Cozumel Cape Resort and Spa': '2859',
  'Dreams Curacao Resort Spa and Casino': '5975',
  'Dreams Dominicus La Romana': '8859',
  'Dreams Flora Resort & Spa': '6077',
  'Dreams Huatulco': '549',
  'Dreams Jade Resort & Spa': '5334',
  'Dreams Karibana Cartagena Golf & Spa Resort': '5231',
  'Dreams Las Mareas Costa Rica': '9506',
  'Dreams Los Cabos Golf Resort & Spa': '126',
  'Dreams Macao Beach Punta Cana Resort and Spa': '7014',
  'Dreams Natura': '5208',
  'Dreams Onyx Resort & Spa': '45121',
  'Dreams Playa Bonita Panama': '6538',
  'Dreams Playa Mujeres Golf & Spa Resort': '7978',
  'Dreams Riviera Cancun Resort & Spa': '120',
  'Dreams Royal Beach Punta Cana': '84595',
  'Dreams Sands Cancun': '9602',
  'Dreams Sapphire': '3525',
  'Dreams Tulum': '198',
  'Dreams Vallarta Bay': '6077',
  'Dreams Vista Cancun Golf & Spa Resort': '8563',
  'Now Emerald Cancun': '6844',
  'Secrets Akumal Riviera Maya': '7547',
  'Secrets Aura Cozumel': '7349',
  'Secrets Bahia Mita Surf & Spa': '7034',
  'Secrets Cap Cana Resort & Spa': '4055',
  'Secrets Huatulco Resort & Spa': '940',
  'Secrets Maroma Beach Riviera Cancun': '721',
  'Secrets Moxche Playa del Carmen': '3051',
  'Secrets Papagayo Costa Rica Resort & Spa': '4853',
  'Secrets Playa Mujeres Golf & Spa Resort': '4994',
  'Secrets Puerto Los Cabos Golf & Spa Resort': '45376',
  'Secrets Riviera Cancun': '8293',
  'Secrets Royal Beach Punta Cana': '627',
  'Secrets St. James Montego Bay': '846',
  'Secrets St. Martin Resort & Spa': '8755',
  'Secrets The Vine Cancun': '978',
  'Secrets Vallarta Bay Puerto Vallarta': '919',
  'Secrets Wild Orchid Montego Bay': '719',
  'Sunscape Akumal Beach Resort & Spa': '6023',
  'Sunscape Curacao': '3557',
  'Sunscape Dorado Pacifico Ixtapa': '456',
  'Sunscape Puerto Plata': '6243',
  'Sunscape Puerto Vallarta': '7225',
  'Sunscape Sabor Cozumel': '7439',
  'Zoetry Agua Punta Cana': '542',
  'Zoetry Casa Del Mar': '9988',
  'Zoetry Curacao': '6079',
  'Zoetry Montego Bay': '8419',
  'Zoetry Paraiso de la Bonita': '543',
  'Zoetry Villa Rolandi Isla Mujeres': '1418',
};

/**
 * **Vertical Booking & Blastness Premium**
 *
 * @exports bs_227
 * @category engines
 */
function factory({ window, document, thn }) {

  const engine = {};
  const isBlastnessPremium = [1046362].includes(thn.data.accountUserId);

  /**
     * @memberOf module:bs_227
     * @see {@link onStateChange}
     *
     * @param {object} ctx - The context object.
     */
  engine.onStateChange = function onStateChange(ctx) {
    if (!window.location.hostname.includes('reservations.verticalbooking')) {
      thn.languageCheck().then(function ({ changed }) {
        if (!changed) {
          thn.pageCheck();
        }
      });
    }

  };

  engine.getInstantBookingMountSelector = function getInstantBookingMountSelector() {
    return '.reserve';
  };

  engine.parseInstantBookingRateDetails = function parseInstantBookingRateDetails(element) {
    const container = element.closest('[id*=blocco-tipo]');

    if (!container) {
      return null;
    }
    const searchDataRaw = engine.priceParseData();

    if (!searchDataRaw || !('price' in searchDataRaw)) {
      return null;
    }

    const ids = thn.dataLayerHelper.get('ecommerce.items') || [];
    const perks = [...container.querySelectorAll('[class="pay-cond-short"]')]?.map((el) => el.textContent?.trim()).filter(Boolean);
    const rateId = undefined;
    const rateName = container.querySelector('.row_titolo .sin h2')?.textContent?.trim() || undefined;
    const roomName = container.closest('.campo')?.getAttribute('data-nomecamera')?.trim() || undefined;
    const roomId = ids?.find((rate) => rate?.item_name?.trim() === roomName?.trim())?.item_id || undefined;
    const roomDescription = container.querySelector('.testo_descrizione')?.textContent || undefined;
    const roomPicture = container.closest('.campo')?.querySelector('img')?.getAttribute('src') || undefined;
    const regexNonRefundable = /not refundable|İade edilemez/i;
    const isRefundable = !perks?.some(el => regexNonRefundable.test(el));
    const price = thn.parseNumber(container.querySelector('.main_price')?.textContent);
    const rateDetails = {
      rateId,
      rateName,
      roomName,
      roomId,
      roomDescription,
      roomPicture,
      isRefundable,
      perks,
      currency: searchDataRaw.currency || '',
      dateBegin: searchDataRaw.dateBegin || '',
      dateEnd: searchDataRaw.dateEnd || '',
      adults: searchDataRaw.adults,
      children: searchDataRaw.children,
      price,
    };

    return rateDetails;
  };

  /**
     * @memberOf module:bs_227
     * @see {@link language_check}
     *
     * @param {object} ctx - The context object.
     */
  engine.languageCheck = function languageCheck(ctx) {

    return new Promise(function (resolve, reject) {

      const $ = window.jQuery;
      const langPattern = {
        Italiano: 'it',
        lang_ita: 'it',
        English: 'en',
        lang_eng: 'en',
        Deutsch: 'de',
        Français: 'fr',
        Русский: 'ru',
        Español: 'es',
        Nederlands: 'nd',
        Türkçe: 'tr',
        Português: 'pt',
        Suomi: 'fi',
        简体中文: 'zh',
        한국어: 'ko',
        日本語: 'ja',
        ภาษาไทย: 'th',
        Norsk: 'no',
        Svenska: 'sv',
        Brazilian: 'pt',
        Hrvatski: 'hr',
        eng: 'en',
        ita: 'it',
        deu: 'de',
        fra: 'fr',
        esp: 'es',
        rus: 'ru',
        dut: 'nd',
        tur: 'tr',
        por: 'pt',
        fin: 'fi',
        chi: 'zh',
        kor: 'ko',
        jpn: 'ja',
        tha: 'th',
        nor: 'no',
        sve: 'sv',
        hrv: 'hr',
        slo: 'sl',
      };

      let langEl;

      const selectumResortPIDs = [1036234, 1041839, 1036231];
      if (selectumResortPIDs.includes(thn.data.propertyId) && !window.location.hostname.includes('reservations.verticalbooking')) {
        langEl = document.querySelector('.lang-selector label')?.textContent;
        if (langEl && ctx.langs.test(langEl)) {
          resolve(langEl);
          return;
        }
      }

      // Kirman Hotels Home page
      if (thn.data.accountUserId === 1044862 && !window.location.hostname.includes('reservation')) {
        langEl = document.querySelector('.language-btn').innerText.trim().toLowerCase();
        if (langEl && ctx.langs.test(langEl)) {
          resolve(langEl);
          return;
        }
      }

      if (window.location.hostname === 'www.calacuncheddi.com') {
        const langPath = window.location.pathname.match(/english|deutsch|fr/);
        langEl = Array.isArray(langPath) ? langPath[0] : '/';
        switch (langEl) {
          case 'english':
            resolve('en');
            return;
          case 'deutsch':
            resolve('de');
            return;
          case 'fr':
            resolve('fr');
            return;
          default:
            resolve('it');
            return;
        }
      }

      const langHome = ((document.querySelector('li.sel') && document.querySelector('li.sel').getAttribute('class')) || '').match(/\w{2}$/);
      if (langHome) {
        langEl = langHome[0];
        if (langEl && ctx.langs.test(langEl)) {
          resolve(langEl);
          return;
        }
      }
      /* Get language from the selector (only available way) */
      langEl = (($ && $('.lang').context?.activeElement?.className?.trim())
                || document.querySelector('.lang')?.textContent?.trim());
      if (langEl) {
        langEl = langPattern[langEl];
        if (langEl && ctx.langs.test(langEl)) {
          resolve(langEl);
          return;
        }
      }

      const lang = window.b_params?.lingua_int || thn.parseUrlParameter('lingua_int');
      if (lang && ctx.langs.test(langPattern[lang])) {
        resolve(langPattern[lang]);
        return;
      }

      reject('no_language');
    });
  };

  /**
     * @memberOf module:bs_227
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine.generateSearchUrl = function generateSearchUrl(ctx) {
    // Created an alternative Generate Search URL function for amrcollection
    if (ctx.baseUrl.includes('booking.hyattinclusivecollection') && ctx.baseUrl.match(/index(\d)?.html/)) {
      return engine._generateSearchUrlAMR(ctx);
    }

    const elAlbergo = document.querySelector('input[name=id_albergo], input[id=id_albergo]');
    const elDc = document.querySelector('input[name=dc_albergo], input[id=dc_albergo], input[name=dc], input[id=dc]');
    let idAlbergo = elAlbergo && elAlbergo.value;
    const url = new URL(ctx.baseUrl);
    let idDc = (elDc && elDc.value) ?? url.searchParams.get('dc');

    const languageDictionary = {
      en: 'eng',
      it: 'ita',
      de: 'deu',
      fr: 'fra',
      es: 'esp',
      ru: 'rus',
      nd: 'dut',
      tr: 'tur',
      pt: 'por',
      fi: 'fin',
      zh: 'chi',
      ko: 'kor',
      ja: 'jpn',
      th: 'tha',
      no: 'nor',
      sv: 'sve',
      hr: 'hrv',
    };

    const albergoId = {
      1016492: 20353,
      1016799: 11761,
      1045322: 24655,
      1045318: 24654,
      1045321: 24653,
      1045319: 24652,
      1045323: 24651,
      1045320: 24650,
      1027380: 21781,
      1027216: 19957,
      1029546: 10032,
      1027768: 19752,
      1027769: 19758,
      1027770: 19754,
      1027767: 19753,
      1027773: 19751,
      1027786: 19757,
      1027787: 19755,
      1027785: 19756,
      1028019: 19759,
      1155107: 20912,
      1055174: 20927,
      1037100: 12246,
      1027459: 23451,
      1026808: 23452,
      1051774: 20715,
      1051778: 19458,
      1051776: 19459,
      1051773: 23178,
      1054431: 27619,
      1036843: 23384,
    };

    const dcId = {
      1016492: 7374,
      1016799: 6737,
      1045322: 9958,
      1045318: 3239,
      1045321: 3711,
      1045319: 3301,
      1045323: 8833,
      1045320: 9316,
      1027380: 9972,
      1027216: 1769,
      1029546: 639,
      1027768: 9373,
      1027769: 8956,
      1027770: 3687,
      1027767: 7369,
      1027773: 2371,
      1027786: 6623,
      1027787: 3091,
      1027785: 7049,
      1028019: 4738,
      1155107: 3974,
      1055174: 7166,
      1037100: 5878,
      1027459: 3866,
      1026808: 9899,
      1036843: 1252,
    };

    const bookingUrlByProperty = {
      1016867: 'https://booking.luganodante.com',
      1029546: 'https://secure.parkhotelbrasilia.com',
      1027380: 'https://booking.mythic-resort.com',
      1027216: 'https://booking.marguery-villas-resort.com',
      1027459: 'https://bookings.hotelpromessisposi.it',
      1026808: 'https://bookings.casa-sullalbero.eu',
    };

    const bookingUrlByUser = {
      1044862: 'https://reservation.kirmanhotels.com',
      1038012: 'https://booking.losinj-hotels.com',
      1037739: 'https://booking.voihotels.com',
      1047342: 'https://reservation.worldofsunrise.com',
      1046174: 'https://reservation.themarmarahotels.com',
      1042129: 'https://reservation.ngphaselisbay.com',
    };

    if (!idAlbergo) {
      idAlbergo = albergoId[thn.data.propertyId];
    }
    if (!idDc) {
      idDc = dcId[thn.data.propertyId];
    }

    if (!idDc || !idAlbergo) {
      ctx.newUrl = ''; // not enough info to generate the url
    } else {
      const bookingEngineUrl = isBlastnessPremium ? 'https://www.blastnessbooking.com' : 'https://reservations.verticalbooking.com';
      const bookingUrl = bookingUrlByProperty[thn.data.propertyId] || bookingUrlByUser[thn.data.accountUserId] || bookingEngineUrl;
      const dateBeginParts = ctx.newData.dateBegin.split(/[-/\\]/);
      const dateEndParts = ctx.newData.dateEnd.split(/[-/\\]/);
      const idStile = thn.parseUrlParameter('id_stile') || '';
      // Refactor needs to be made!!! Temporary solution
      ctx.newUrl = `${bookingUrl}/premium/index2.html?id_stile=${idStile}&lingua_int=[language]&id_albergo=${idAlbergo}&dc=${idDc}&adulti1=[adults]&bambini1=[children]&tot_camere=[rooms]&tot_adulti=[adults]&tot_bambini=[children]&gg=${dateBeginParts[2]}&mm=${dateBeginParts[1]}&aa=${dateBeginParts[0]}&ggf=${dateEndParts[2]}&mmf=${dateEndParts[1]}&aaf=${dateEndParts[0]}`;
      ctx.newData.language = languageDictionary[ctx.newData.language] || 'en';
      ctx.newData.dateBeginYear = dateBeginParts[0];
      ctx.newData.dateBeginMonth = dateBeginParts[1];
      ctx.newData.dateBeginDay = dateBeginParts[2];

      ctx.newData.dateEndYear = dateEndParts[0];
      ctx.newData.dateEndMonth = dateEndParts[1];
      ctx.newData.dateEndDay = dateEndParts[2];

    }

    return ctx;
  };

  /**
     * @memberOf module:bs_227
     * @see {@link generate_search_url}
     *
     * @param {object} ctx - The context object.
     */
  engine._generateSearchUrlAMR = function generateSearchUrlAMR(ctx) {
    const baseUrl = new URL(ctx.baseUrl);
    // When the url is already valid we just need to replace our parameters
    const url = baseUrl.searchParams.has('id_albergo')
      ? new URL(ctx.baseUrl)
      : new URL(baseUrl.pathname, baseUrl);

    const langDictionary = {
      en: 'eng',
      it: 'ita',
      de: 'deu',
      fr: 'fra',
      es: 'esp',
      ru: 'rus',
      nd: 'dut',
      tr: 'tur',
      pt: 'por',
      fi: 'fin',
      zh: 'chi',
      ko: 'kor',
      ja: 'jpn',
      th: 'tha',
      no: 'nor',
      sv: 'sve',
    };

    url.searchParams.set('lingua_int', '[language]');
    url.searchParams.set('gg', '[arrivalDay]');
    url.searchParams.set('mm', '[arrivalMonth]');
    url.searchParams.set('aa', '[arrivalYear]');
    url.searchParams.set('tot_camere', '[rooms]');
    url.searchParams.set('tot_adulti', '[adults]');
    url.searchParams.set('tot_bambini', '[children]');
    url.searchParams.set('notti_1', '[nights]');
    url.searchParams.set('ggf', '[departureDay]');
    url.searchParams.set('mmf', '[departureMonth]');
    url.searchParams.set('aaf', '[departureYear]');

    const dlPropertyName = thn.objectGet(window.dataLayer, 'propertyName', { first: false })?.trim();

    if (!url.searchParams.get('id_albergo')) {
      url.searchParams.set('id_albergo', '[id_albergo]');
      if (idAlbergoDictionary[dlPropertyName]) {
        ctx.newData.id_albergo = idAlbergoDictionary[dlPropertyName];
      }
    }

    if (!url.searchParams.get('dc')) {
      url.searchParams.set('dc', '[dc]');
      if (dcDictionary[dlPropertyName]) {
        ctx.newData.dc = dcDictionary[dlPropertyName];
      }
    }

    ctx.newData.language = langDictionary[ctx.newData?.language] || 'eng';

    const dateBegin = ctx.newData?.dateBegin || ctx.data?.dateBegin;
    const dateEnd = ctx.newData?.dateEnd || ctx.data?.dateEnd;
    if (dateBegin && dateEnd) {
      ctx.newData.nights = thn.daysBetween(dateBegin, dateEnd);
    }
    if (dateBegin) {
      const dateBeginParts = dateBegin?.split(/[-/\\]/);
      ctx.newData.arrivalDay = dateBeginParts[2];
      ctx.newData.arrivalMonth = dateBeginParts[1];
      ctx.newData.arrivalYear = dateBeginParts[0];
    }
    if (dateEnd) {
      const dateEndParts = dateEnd?.split(/[-/\\]/);
      ctx.newData.departureDay = dateEndParts[2];
      ctx.newData.departureMonth = dateEndParts[1];
      ctx.newData.departureYear = dateEndParts[0];
    }

    ctx.newUrl = url.toString();

    return ctx;
  };

  /**
     * @memberOf module:bs_227
     * @this thn.widgets.price
     * @see {@link Price#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceObserveDom = function priceObserveDom(ctx) {

    const container = document.querySelector('#box-risultati');
    let priceUpdate;

    if (container && !priceUpdate) {
      priceUpdate = thn.debounce(() => {
        const loader = thn.isVisible(document.querySelector('.spinner-conntainer'));
        if (!loader) {
          ctx.widget.refresh();
        }
      }, 500);

      thn.observeDom(container, priceUpdate, {
        subtree: true,
      });

      thn.pageUnload(function () {
        priceUpdate.cancel();
        thn.stopObserveDom(container, priceUpdate);
        priceUpdate = null;
      });
    }

    const refreshPageByDataLayer = ({ message }) => {
      if (message?.[0] === 'event' || message?.event === 'page_view' || message?.event === 'view_item_list') {
        ctx.widget.refresh();
      }
    };

    thn.bus.on('dataLayer:push', refreshPageByDataLayer);
    thn.shutdown(() => {
      thn.bus.detach('dataLayer:push', refreshPageByDataLayer);
    });
  };

  const roomDetailsParseData = (adults, children, nights) => {
    const roomsArray = [...document.querySelectorAll('.campo')];

    if (!roomsArray) {
      return undefined;
    }

    const roomsInfo = [...roomsArray].map((room) => {
      const roomNameEl = room?.querySelector('.nome_camera');
      const roomName = roomNameEl?.textContent;
      const roomType = getRoomType(roomName);

      const roomRates = [...room.querySelectorAll('.blocco_tipo')]
        .map((rate) => {
          const rateName = rate.querySelector('.row_titolo .sin h2')?.textContent.trim();
          const price = thn.parseNumber(rate.querySelector('.room-rate-list')?.dataset?.price);
          const breakfastRegex = /Breakfast|desayuno incluidos|Petit-Déjeuner Inclus|Kahvaltı|Mezza Pensione|Pensione completa|prima colazione/;
          const refundableRegex = /Free cancellation|Annulation gratuite|Cancelación gratuita|Ücretsiz iptal|CANCELLAZIONE GRATUITA|БЕСПЛАТНОЕ АННУЛИРОВАН/;
          const hasBreakfast = breakfastRegex.test(rate.querySelector('.row_titolo .sin p, .room-rate-treatment-box-item')?.textContent) || !!rate.querySelector('.fas.fa-coffee');
          const isRefundable = refundableRegex.test(rate.querySelector('.pay-cond-short')?.textContent);
          const rateInfo = {
            id: '',
            name: rateName,
            totalNight: price / nights,
            breakfast: hasBreakfast,
            refundable: isRefundable,
          };

          return rateInfo;
        });

      return {
        id: '',
        name: roomName,
        adults: adults || 2,
        children: children || 0,
        type: roomType,
        prices: roomRates,
      };

    }).filter(Boolean);

    return roomsInfo;

  };

  const blockPWwithPromo = () => {
    const userToBlockIds = [1040542];
    const promoParamRegex = /generic_codice|codice_convenzione|sconto|codice_cli/;
    const promoParam = window.location.search.match(promoParamRegex)?.[0];
    const promoWhiteList = ['5OFFWOH', '200AMSGC'];

    return userToBlockIds.includes(thn.data.accountUserId) && promoParam && !promoWhiteList.includes(thn.parseUrlParameter(promoParam));
  };

  /**
     * @memberOf module:bs_227
     * @this thn.widgets.price
     * @see {@link Price#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.priceParseData = function priceParseData(ctx) {

    const widgetData = {};
    const $ = window.jQuery;

    if (!$) {
      return widgetData;
    }
    // mark priceSpecial for Easter Weekend campaign
    if (thn.data.accountUserId === 1038012 && !!document.location.pathname.match(/index_pacchetti_3\.html/)) {
      widgetData.priceSpecial = 1;
    }

    // No Rooms div ID
    const noRoomsDiv = $('#messaggio_no_soluzioni').get(0);

    function formatDaysMonths(dayMonth) {
      return dayMonth.length === 1 ? '0'.concat('', dayMonth) : dayMonth;
    }

    // Dates
    let nights;

    // Some properties has the price per night, we don't need to divide with the number of nights
    const pricePerNightWhitelist = [1026345, 1033485, 1027216, 1027380, 1044872].includes(thn.data.propertyId);

    // Checks if input 'aa' and input 'aaf' exist before asigning any value to dates
    const dateBegin = $('input[name="aa"]').val() && (`${$('input[name="aa"]').val()}/${formatDaysMonths($('input[name="mm"]').val())}/${formatDaysMonths($('input[name="gg"]').val())}`);
    const dateEnd = $('input[name="aaf"]').val() && (`${$('input[name="aaf"]').val()}/${formatDaysMonths($('input[name="mmf"]').val())}/${formatDaysMonths($('input[name="ggf"]').val())}`);

    if (dateBegin) {
      widgetData.dateBegin = dateBegin;
      const inputNights = thn.parseNumber($('input[name="notti_1"]').val());

      if (dateEnd || inputNights) {
        widgetData.dateEnd = dateEnd || thn.dateToString(thn.addDays(widgetData.dateBegin, inputNights));
        nights = inputNights || thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
      }
    }

    // Guests, Adults & Children
    const room = parseInt((document.querySelector('.seleziona_camera .val') && document.querySelector('.seleziona_camera .val').textContent), 10) || 1;
    widgetData.adults = parseInt((document.querySelector(`input[name=adulti${room}]`) && document.querySelector(`input[name=adulti${room}]`).value), 10) || 2;
    widgetData.children = parseInt((document.querySelector(`input[name=bambini${room}]`) && document.querySelector(`input[name=bambini${room}]`).value), 10) || 0;
    widgetData.guests = widgetData.adults + widgetData.children;

    // if children, build the room_info
    if (widgetData.children > 0) {
      // build the detailed room information
      widgetData.roomsDispo = [];
      const roomInfo = {
        adults: widgetData.adults,
        children: widgetData.children,
        childrenAges: [],
      };
      for (let i = 1; i <= widgetData.children; i += 1) {
        roomInfo.childrenAges.push(parseInt(document.querySelector(`input[name=st${room}bamb${i}]`) && document.querySelector(`input[name=st${room}bamb${i}]`).value, 10) || 10);
      }

      widgetData.roomsDispo.push(roomInfo);
    }

    // Prices & Currency || No Rooms
    const priceElems = document.querySelectorAll('.room-rate-price-value-content, .best_price_at_all, .buona_tariffa');
    widgetData.currency = thn.dataLayerHelper.get('ecommerce.currency');
    const domPrices = [...priceElems].map((el) => {
      if (!widgetData.currency) {
        widgetData.currency = thn.parseCurrency(el.textContent);
      }
      if (el.querySelector('.offer')) {
        return thn.parseNumber(el.querySelector('.offer').textContent);
      } // When there are offers on the page, the price is within an offer class
      return thn.parseNumber(el.querySelector('span.amount')?.getAttribute('data-best-price') || el.textContent);
    }).filter(Boolean);
    const dataLayerPrices = thn.dataLayerHelper.get('ecommerce.items')?.map((rate) => rate.price).filter(Boolean);
    const price = dataLayerPrices && dataLayerPrices.length > 0 ? Math.min(...dataLayerPrices) : Math.min(...domPrices);

    if (price && widgetData.currency && nights && !blockPWwithPromo()) {
      widgetData.price = pricePerNightWhitelist ? price : price.toFixed(2) / nights;
      widgetData.roomDetails = roomDetailsParseData(widgetData.adults, widgetData.children, pricePerNightWhitelist ? 1 : nights);
      widgetData.set = true;
    } else if (noRoomsDiv) {
      widgetData.noRooms = true;
    }

    return widgetData;
  };

  /**
     * @memberOf module:bs_227
     * @this thn.widgets.booking
     * @see {@link Booking#observe_dom}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingObserveDom = function bookingObserveDom(ctx) {

    const dataLayer = window.dataLayer;

    if (dataLayer) {
      // eslint-disable-next-line no-unused-vars
      let bookingRefresh = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
        if ((message.event === 'trackTrans' || message.event === 'reservationConfirmation') && ctx.widget.setData().isSet()) {
          ctx.widget.save();
        }
      }, true);
      thn.pageUnload(() => {
        bookingRefresh.cancel();
        bookingRefresh = null;
      });
    }
  };

  /**
     * @memberOf module:bs_227
     * @this thn.widgets.booking
     * @see {@link Booking#set_data}
     *
     * @param {object} ctx - The context object.
     */
  engine.bookingParseData = function bookingParseData(ctx) {

    const widgetData = {};

    // The dataLayer is used to collect information in the mobile version and the desktop version uses DOM elements
    const dataLayer = window.dataLayer || {};
    // Fallback data from DOM elements
    const dataFallBackEls = document.querySelectorAll('#box-prenotazioni .colonna2 .colonnaDx .valore');
    // Booking ID
    const bookingId = thn.parseUrlParameter('ultimo_codice') || document.querySelector('input[name="ultimo_codice"]')?.value
            || (document.querySelector('.summary_value_code')?.innerText)?.split('\n')?.[1]
            || dataFallBackEls?.[0]?.textContent;
    const bookingIdByDataLayer = thn.dataLayerHelper.get('transactionId')?.split('-')?.[1];

    if (!bookingId && !bookingIdByDataLayer) {
      widgetData.set = false;
      return widgetData;
    }

    widgetData.bookingId = bookingId || bookingIdByDataLayer;

    // Dates
    const TICINO_HOTELS_UID = 1037746;

    if (thn.data.accountUserId === TICINO_HOTELS_UID) {
      const purchaseData = thn.objectGet(dataLayer, 'purchase')?.products[0];
      widgetData.dateBegin = purchaseData?.checkinDate?.replace(/-/g, '/');
      widgetData.dateEnd = purchaseData?.checkoutDate?.replace(/-/g, '/');

    } else {
      const datesSel = document.querySelectorAll('.print_email.printMe > table > tbody > tr:nth-child(4) > td > table:nth-child(1) tbody > tr td:nth-child(2) > span:nth-child(1) > span span');

      // MJ Holidays chain
      const mjHolidaysUid = thn.data.accountUserId === 1037438;
      const mjHolidayDatesSel = document.querySelectorAll('.mcnTextContentContainer')[3]?.querySelectorAll('p');
      const datesArrayEl = (datesSel.length && datesSel) || (mjHolidayDatesSel?.length && mjHolidayDatesSel) || [];
      const dateBegin = mjHolidaysUid ? datesArrayEl[1]?.textContent : datesArrayEl[0]?.textContent;
      const dateEnd = mjHolidaysUid ? datesArrayEl[3]?.textContent : datesArrayEl[1]?.textContent;
      // dates fallback
      const datesFallback = dataFallBackEls?.[2]?.textContent?.trim()?.split('-');

      if (dateBegin && dateEnd && !datesFallback) {
        widgetData.dateBegin = translateDate(dateBegin, thn.data.language || 'en');
        widgetData.dateEnd = translateDate(dateEnd, thn.data.language || 'en');
      } else if ((datesFallback && datesFallback.length === 2) && !dateBegin && !dateEnd) {
        widgetData.dateBegin = translateDate(datesFallback[0].trim(), thn.data.language || 'en');
        widgetData.dateEnd = translateDate(datesFallback[1].trim(), thn.data.language || 'en');
      } else {
        widgetData.dateBegin = thn.dateToString(thn.dataLayerHelper.get('checkInDate')) || thn.dataLayerHelper.get('arrivalDate')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$3/$2');
        widgetData.dateEnd = thn.dateToString(thn.dataLayerHelper.get('checkOutDate')) || thn.dataLayerHelper.get('departureDate')?.replace(/(\d+)\D+(\d+)\D+(\d+)/, '$1/$3/$2');
      }
    }

    // Price & Currency
    const price = document.querySelector('.riga.prezzi .risultato')?.textContent || thn.dataLayerHelper.get('transactionProducts')?.[0]?.price
            || document.querySelector('.summary_value_total_room_rate')?.innerText;
    widgetData.price = thn.parseNumber(price) || parseFloat(window.orderValue);
    widgetData.currency = thn.parseCurrency(price) || thn.getCurrencyCode(window.currencyCode) || thn.dataLayerHelper.get('currency');

    // Guests
    // From each room card
    const totalGuests = Array.from(document.querySelectorAll('#box-risultati .thanks-page .tariffe')).reduce((total, el) => {
      const children = el.querySelectorAll('.icon-bambino').length;
      const adults = el.querySelectorAll('.fa-user').length - children;
      total.adults += adults;
      total.children += children;
      return total;
    }, { adults: 0, children: 0 });

    // From summary info
    const totalBookingInfo = Array.from(document.querySelectorAll('#carrello .eti .dx'));
    const totalAdults = totalBookingInfo[1]?.textContent;
    const totalChildren = totalBookingInfo[2]?.textContent;
    // Fallback from dataFallBackEls
    const guestsFallback = dataFallBackEls?.[4]?.textContent?.trim()?.split('-');

    widgetData.adults = thn.parseNumber(totalGuests.adults || totalAdults || guestsFallback?.[0]);
    widgetData.children = thn.parseNumber(totalGuests.children || totalChildren || guestsFallback?.[1]);

    return widgetData;
  };

  /**
   * @memberOf module:bs_227
   * @this thn.widgets.price
   * @see {@link Price#get_promocode}
   *
   * @param {object} ctx - The context object.
   */
  engine.getPromocode = function getPromocode(ctx) {

    ctx.promocode = thn.parseUrlParameter('generic_codice') || document.querySelector('#qr_generic')?.value;

    return ctx.promocode;
  };

  return engine;

}

export { factory };
